import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { AUTSlider, CarCard } from '../../../../components';
import { useScreen } from 'usehooks-ts'
import './index.scss';

const StyledTypography = styled(Typography)`
  && {
    font-weight: 700;
    font-size: 18px;
    color: #212121;
    margin: 0 0 12px 0;
  }
`;

const StyledArrowsGrid = styled(Grid)`
  && {
    display: block;

    .disabled {
      opacity: 0.2;
      cursor: default;
    }
  }
`;

const SuggestionsBlock = ({ pivotIndex, pivotIndexMobile, data, blockTitle, isLoading }) => {
  const [prevArrowDisabled, setPrevArrowDisabled] = React.useState(false);
  const [nextArrowDisabled, setNextArrowDisabled] = React.useState(false);
  const slider = React.useRef(null);
  const screen = useScreen()

  React.useEffect(() => {
    if (!data || !data.length) return;
    const perPage = screen?.width > 769 ? 4 : 2;
    const index = screen?.width > 769 ? pivotIndex : pivotIndexMobile;
    setPrevArrowDisabled(index === 0);
    setNextArrowDisabled(data.length - index <= perPage);
    if (slider.current) {
      // a hack because slider does not rerender for some reason
      slider.current.slickGoTo(index)
    }
  }, [data, pivotIndex, pivotIndexMobile, screen]);

  const nextSlide = () => {
    slider.current.slickNext();
  };

  const prevSlide = () => {
    slider.current.slickPrev();
  };

  const beforeChange = (oldIndex, newIndex) => {
    const slidesToShow = screen?.width > 769 ? 4 : 2;

    setPrevArrowDisabled(false);
    setNextArrowDisabled(false);

    if (newIndex === 0) {
      setPrevArrowDisabled(true);
    }

    if (data && data.length - newIndex <= slidesToShow) {
      setNextArrowDisabled(true);
    }
  };

  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: pivotIndex,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          initialSlide: pivotIndexMobile
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          initialSlide: pivotIndexMobile
        }
      }
    ]
  };

  if (!isLoading && data && data.length > 0) {
    return (
      <div className="slider-container suggestions">
        <Grid container justify="space-between">
          <StyledTypography>{blockTitle}</StyledTypography>
          <StyledArrowsGrid item>
            <i
              className={`material-icons prev ${prevArrowDisabled ? 'disabled' : ''}`}
              onClick={prevSlide}
              onKeyPress={prevSlide}
              role="button"
              tabIndex="0"
              disabled={prevArrowDisabled}
            >
              arrow_back
            </i>
            <i
              className={`material-icons prev ${nextArrowDisabled ? 'disabled' : ''}`}
              onClick={nextSlide}
              onKeyPress={nextSlide}
              role="button"
              tabIndex="0"
              disabled={nextArrowDisabled}
            >
              arrow_forward
            </i>
          </StyledArrowsGrid>
        </Grid>
        <AUTSlider
          className="suggestions-slider"
          sliderRef={c => (slider.current = c)} // eslint-disable-line
          settings={settings}
          beforeChange={beforeChange}
        >
          {data.map((item, i) => (
            <CarCard key={`r${i}`} vehicle={item} />
          ))}
        </AUTSlider>
      </div>
    );
  }
  return null;
};

export default SuggestionsBlock;
